import { observable } from 'mobx';
import type { Moment } from '@this/src/lib/moment';
import moment from '@this/src/lib/moment';

export type OrderItemStepTimeResponseArgs = {
  id: number;
  started_at: string;
  finished_at?: string | null;
  duration?: number | null;
};

export type OrderItemStepTimeArgs = {
  id: number;
  startedAt: Moment;
  finishedAt?: Moment | null;
  duration?: number | null;
};

export const convertOrderItemStepTimeResponseToArgs = (response: OrderItemStepTimeResponseArgs) => {
  const args: OrderItemStepTimeArgs = {
    id: response.id,
    startedAt: moment(response.started_at),
    finishedAt: response.finished_at ? moment(response.finished_at) : null,
    duration: response.duration ?? undefined
  };
  return args;
};

export default class OrderItemStepTime {
  @observable readonly id: number;
  @observable readonly startedAt: Moment;
  @observable readonly finishedAt?: Moment | null;
  @observable readonly duration?: number | null;

  constructor(args: OrderItemStepTimeArgs) {
    this.id = args.id;
    this.startedAt = args.startedAt;
    this.finishedAt = args.finishedAt;
    this.duration = args.duration;
  }
}
